import { useState } from "react";

interface ShareModalProps {
  title: string;
  onClose: () => void;
}

const channels = [
  { key: "wechat", label: "微信", icon: "ri-wechat-line" },
  { key: "weibo", label: "微博", icon: "ri-weibo-line" },
  { key: "qq", label: "QQ", icon: "ri-qq-line" },
  { key: "link", label: "复制链接", icon: "ri-link" },
];

export default function ShareModal({ title, onClose }: ShareModalProps) {
  const [feedback, setFeedback] = useState("");

  const handleShare = async (key: string, label: string) => {
    if (key === "link") {
      try {
        await navigator.clipboard.writeText(window.location.href);
        setFeedback("链接已复制到剪贴板");
      } catch {
        setFeedback("复制失败，请手动复制地址栏链接");
      }
      return;
    }
    setFeedback(`已生成「${label}」分享内容（演示功能，未真实调用）`);
  };

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-foreground-950/50" onClick={onClose} />
      <div className="relative w-full max-w-md rounded-lg border border-background-200 bg-background-50 p-6">
        <div className="flex items-start justify-between">
          <div>
            <h2 className="text-base font-semibold text-foreground-950">分享作品</h2>
            <p className="mt-1 line-clamp-1 text-sm text-foreground-500">{title}</p>
          </div>
          <button
            type="button"
            aria-label="关闭"
            onClick={onClose}
            className="flex h-8 w-8 items-center justify-center rounded-full bg-background-100 text-foreground-700"
          >
            <i className="ri-close-line text-lg" />
          </button>
        </div>

        <div className="mt-6 grid grid-cols-4 gap-3">
          {channels.map((channel) => (
            <button
              key={channel.key}
              type="button"
              onClick={() => handleShare(channel.key, channel.label)}
              className="flex flex-col items-center gap-2 rounded-lg border border-background-200 bg-background-50 py-4 transition-colors hover:border-primary-300"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-background-100 text-primary-600">
                <i className={`${channel.icon} text-xl`} />
              </span>
              <span className="whitespace-nowrap text-xs text-foreground-700">{channel.label}</span>
            </button>
          ))}
        </div>

        {feedback && (
          <p className="mt-5 flex items-center gap-2 rounded-md bg-accent-100 px-3 py-2.5 text-xs text-accent-900">
            <i className="ri-information-line" />
            {feedback}
          </p>
        )}
        <p className="mt-3 text-center text-[11px] text-foreground-400">
          注：分享功能仅为前端演示，不会真实发布到第三方平台
        </p>
      </div>
    </div>
  );
}